var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserphoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1035_18325",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 232,
    height: 232
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    width: 232,
    height: 232,
    rx: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1035_18325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M232.002 0H0V231.907H232.002V0Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M157.373 209.432C130.651 199.959 103.627 200.284 76.6875 209.432V184.138C103.806 177.2 130.686 177.655 157.373 184.138V209.432Z",
    fill: "url(#paint0_linear_1035_18325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M146.028 162.6C144.011 162.588 147.646 188.228 149.512 194.377C153.767 208.399 205.837 220.271 206.224 229.574C206.324 231.999 206.224 232.001 206.224 232.001H30.0254L46.4314 216.223L58.9151 212.986L65.5544 209.849C66.8321 209.245 68.043 208.51 69.1684 207.656L82.8128 197.3C82.8128 197.3 87.0936 191.95 86.737 183.858C86.3804 175.767 86.3804 162.598 86.3804 162.598H146.028V162.6Z",
    fill: "url(#paint1_linear_1035_18325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.141 123.097C75.141 123.097 65.8033 105.693 64.1615 102.989C62.5198 100.285 65.3928 91.0072 64.1615 89.0757C62.9303 87.1424 62.5198 58.9287 72.3701 50.4249C82.2204 41.921 87.9646 39.6033 87.9646 39.6033C90.403 37.4991 106.631 31.573 113.452 32.6464C133.968 35.876 130.554 34.8174 134.341 34.5797C143.051 35.9837 149.702 38.3293 148.673 44.0363C151.952 42.3481 154.56 42.3296 157.325 44.2424C156.562 45.8563 156.465 46.9167 157.325 47.7209C157.325 47.7209 167.996 48.1071 167.996 74.7757C167.996 101.444 166.004 109.638 163.071 111.107C160.139 112.576 154.733 117.798 154.733 117.798C154.733 117.798 156.094 71.3122 142.962 71.6836C129.828 72.055 120.203 78.6683 88.3787 71.6836C81.4014 70.1514 71.4508 113.822 75.1447 123.099L75.141 123.097Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M74.0655 139.442C74.0655 139.442 79.7205 167.167 93.9388 175.773C116.139 189.211 131.384 177.814 131.384 177.814C131.384 177.814 149.098 161.941 152.002 152.583C154.597 144.224 155.509 139.442 155.509 139.442C155.509 139.442 157.847 139.442 159.405 137.508C160.963 135.575 161.353 123.208 162.523 119.728C163.693 116.248 164.471 110.452 160.575 110.838C156.679 111.224 154.731 117.795 154.731 117.795C154.731 117.795 158.268 106.104 155.93 99.1471C153.592 92.1903 155.121 77.5968 145.768 71.7988C136.415 66.0008 124.507 67.9341 118.771 69.8655C113.034 71.7988 100.955 70.6381 93.5507 67.9322C86.1463 65.2264 77.8727 77.5281 76.7045 83.3261C75.5364 89.1241 73.6755 113.154 74.0674 117.791L74.4574 122.428C74.4574 122.428 71.7293 110.06 69.3911 109.287C67.053 108.515 62.7667 108.515 63.5467 117.791C64.3267 127.067 65.272 119.886 68.613 137.116C70.5611 147.165 74.0693 139.436 74.0693 139.436L74.0655 139.442Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M76.6418 184.324C76.6418 184.324 73.2433 204.309 71.0685 204.872C68.8938 205.436 95.2095 218.394 104.883 219.64C104.883 219.64 110.696 209.58 117.209 206.538C117.209 206.538 77.9845 193.227 76.6418 184.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M157.447 184.137C157.447 184.137 161.018 204.082 163.176 204.623C165.334 205.163 139.449 218.403 129.896 219.755C129.896 219.755 124.041 209.758 117.57 206.785C117.57 206.785 156.216 193.053 157.447 184.137Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_18325",
    x1: 76.6894,
    y1: 194.269,
    x2: 157.373,
    y2: 194.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C5C5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABAB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1035_18325",
    x1: 118.147,
    y1: 236.857,
    x2: 118.147,
    y2: 153.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C6BFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFC7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#DCDCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#C1C1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABAB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserphoto);
export default __webpack_public_path__ + "static/media/userphoto.771e9687df6bb4015159aa43b143b98c.svg";
export { ForwardRef as ReactComponent };